module.exports = __webpack_public_path__ + "static/mary-g-ba16a93129c7f2f562074fed1010e0cc.png";